module.exports = __webpack_public_path__ + "img/open_a_table.f5b3d808.svg";